<h2 class="ttl2">Selecciona el plan óptimo para tus necesidades comerciales</h2>
<div class="typeSyteInfo">

  <div class="typeSyteInfo__aside">
    <div class="typeSyteInfo__top">
      <button class="btnPrev" mat-icon-button mat-dialog-close></button>
      <span>Ver opciones</span>
    </div>
    <div class="typeSyteInfo__aside_inner">
      <img src="/assets/images/img-blog.svg" alt="blog">
    </div>
  </div>

  <div class="typeSyteInfo__body">
    <div class="typeSyteInfo__top">
      <h2 class="ttl2">Blog</h2>
    </div>
    <div class="typeSyteInfo__body_inner">
      <ul class="list_check">
        <li>Instalaciones automatizadas de WordPress, Drupal y mucho más para una rápida configuración</li>
        <li>Panel de control de uso fácil, para un óptimo mantenimiento de tus sitios</li>
        <li>Almacenamiento SSD para tiempos de carga rápidos</li>
      </ul>
      <button id="bh-{{landing}}-blog-contratar" (click)="goToUrl(); track($event)" class="btn btnRed" mat-button>CONTRATAR</button>
    </div>
  </div>

</div>